import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  constructor() {}

  private getTimestampUsingIntl(): string {
    const now = new Date();
    const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(now);
    const month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(now);
    const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(now);
    const hours = new Intl.DateTimeFormat('en', { hour: '2-digit', hour12: false }).format(now);
    const minutes = new Intl.DateTimeFormat('en', { minute: '2-digit' }).format(now);
    const seconds = new Intl.DateTimeFormat('en', { second: '2-digit' }).format(now);

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  }

  createBaseRequest(msgType: string, msgData: any): any {
    const baseRequest = {
      MsgInfo: {
        VersionNo: environment.appVersion,
        // MsgID: `${environment.InsID}${this.getTimestampUsingIntl()}`,
        // TimeStamp: this.getTimestampUsingIntl(),
        MsgID: 'CORB2409000120241031180410004999',
        TimeStamp: "20241031180410",
        MsgType: msgType,
        InsID: environment.InsID
      },
        VersionNo: environment.appVersion, // need for Ko KMT local server
        MsgID: 'CORB2409000120241031180410004999',
        TimeStamp: "20241031180410",
        MsgType: msgType,
        InsID: environment.InsID,
        Email: msgData?.Email,
        GrantType: msgData?.GrantType,
        Password: msgData?.Password,
        Provider: msgData?.Provider,
        AuthenticatorCode: msgData?.AuthenticatorCode
    };
    return { ...baseRequest, MsgData: msgData };
  }
}
